/**
 * Explicit recorder-consumer result for files that are safe to remove from durable storage.
 * A file belongs here only once the consumer has stored it outside the browser draft (for
 * example uploaded to the library), so deleting the draft cannot lose the recording.
 */
class RecordedFilesConsumptionResult {
    constructor(consumedRecordedFiles) {
        this._consumedRecordedFiles = Array.isArray(consumedRecordedFiles) ? consumedRecordedFiles.slice() : [];
    }

    getConsumedRecordedFiles() {
        return this._consumedRecordedFiles.slice();
    }
}

export default RecordedFilesConsumptionResult;
